import Icon from '../components/Icon.vue'

Icon.register({
  'h-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M448 80v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM336 128h-32c-8.8 0-16 7.2-16 16v80h-128v-80c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-80h128v80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-224c0-8.8-7.2-16-16-16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/h-square.js
// module id = 1420
// module chunks = 0